import React from "react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { MOCKUP_URL } from "../../data/landing";
export function FinalCtaSection() {
  const needs = ["A case.", "A pathway.", "A few focused questions.", "A way to organize what you see.", "A process for turning each case into a learning opportunity."];
  return <section className="w-full bg-cream px-5 py-16 md:py-24" data-id="element-136" data-mp="2rj4kxke1xga6">
      <div className="mx-auto max-w-3xl text-center" data-id="element-137" data-mp="2rhbdw3zj0u1n">
        <h2 className="font-serif text-[30px] font-bold leading-tight text-ink md:text-5xl" data-id="element-138" data-mp="2mkkzrm7a88iv">
          Ready to stop staring at the case… <em className="text-rose" data-id="element-139" data-mp="317mk5x6onfbp">and start following a pathway?</em>
        </h2>
        <p className="mt-5 text-[17px] text-inkSoft" data-id="element-140" data-mp="2waw2x6j56dop">You don't need another 20-hour lecture. You need:</p>
        <ul className="mx-auto mt-5 max-w-md space-y-2" data-id="element-141" data-mp="3aanktics4e7z">
          {needs.map(n => <li key={n} className="rounded-xl bg-white px-4 py-3 text-[16px] font-semibold text-ink" data-id="element-142" data-mp="368tsbxcqmgiw">
              {n}
            </li>)}
        </ul>

        <img src={MOCKUP_URL} alt="Breast Augmentation Clinical Pathway bundle" className="mx-auto mt-8 w-full max-w-xl" data-id="element-143" data-mp="2626b75mklcsx" />
        <p className="mt-4 font-serif text-xl font-bold text-ink" data-id="element-144" data-mp="2b0px5615yola">Breast Augmentation Clinical Pathway™</p>
        <p className="mt-1 text-[15px] text-inkSoft" data-id="element-145" data-mp="2g0m1559v2g0u">6 Premium Volumes + 5 Professional Bonuses + 30+ Case-Review Tools</p>
        <p className="mt-3 font-serif text-6xl font-extrabold text-cta" data-id="element-146" data-mp="2kynhvjjte395">$27</p>

        <div className="mt-6" data-id="element-147" data-mp="2p08wpafwsrlz">
          <CtaButton label="Get the Breast Augmentation Clinical Pathway™" caption="One-time payment · Instant digital access · Lifetime access · 7-day guarantee" data-id="element-148" data-mp="2oz7i4vzopmzi" />
          <Countdown data-id="element-149" data-mp="2yq23ly53wijw" />
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="w-full bg-ink px-5 pb-32 pt-12 text-center text-white/70" data-id="element-150" data-mp="33rre9cof2u7g">
      <div className="mx-auto max-w-3xl" data-id="element-151" data-mp="38pj7ca0ssmd8">
        <p className="font-serif text-lg font-bold text-white" data-id="element-152" data-mp="2j0vppz9bfxjm">Breast Augmentation Clinical Pathway™</p>
        <p className="mt-2 text-sm" data-id="element-153" data-mp="2e216iw7fs6yz">© 2026 Dr. Michael Carter. All rights reserved.</p>
        <p className="mt-1 text-sm" data-id="element-154" data-mp="2sqoyytlzk0kp">Educational material for qualified medical professionals.</p>
        <p className="mt-6 text-xs leading-relaxed text-white/55" data-id="element-155" data-mp="2ssi4g5kv4er4">
          The Breast Augmentation Clinical Pathway™ is intended for professional education and case-based learning. It
          is not a substitute for formal surgical training, supervision, current clinical guidelines, institutional
          protocols, individualized medical evaluation or professional judgment. The pathway does not provide
          individualized treatment recommendations or guarantee clinical outcomes. Healthcare professionals are
          responsible for applying current evidence, applicable regulations and appropriate clinical judgment to each
          individual patient.
        </p>
      </div>
    </footer>;
}